import {type CreateProps} from '@refinedev/mui';
import {Create as CreateMui} from '@refinedev/mui';
import {FC, ReactNode} from 'react';

import {CustomCreate} from '@components/crud/_partial/custom-create';

type CustomCreateProps = {
  auto?: boolean;
  title?: string | ReactNode;
} & Omit<CreateProps, 'title'>;

/**
 * `<Create>` provides us a layout to display the page.
 * It does not contain any logic but adds extra functionalities like action buttons and giving titles to the page.
 *
 * @see {@link https://refine.dev/docs/ui-frameworks/mui/components/basic-views/create} for more details.
 */
export const Create: FC<CustomCreateProps> = ({auto = false, ...props}) => {
  return auto ? <CreateMui {...props} /> : <CustomCreate {...props} />;
};
